module.exports = __webpack_public_path__ + "img/rnd2.9c4a233a.jpg";